<template>
  <section :class="class" class="flex flex-col gap-2">
    <label v-if="!noLabel" class="text-sm font-semibold" :class="{ required: question.required, optional: !question.required }">
      {{ question.label }}
    </label>
    <div v-if="modelValue" class="flex flex-row flex-wrap items-center justify-center gap-4 p-2">
      <rpm-input
        v-for="option in question.options"
        type="checkbox"
        :label="option.label"
        v-model="modelValue[option.label]"
        class="items-center"
      ></rpm-input>
    </div>
  </section>
</template>

<script>
export default {
  name: "CheckboxGroupAnswer",
  data(){
    return {};
  },
  props: {
    modelValue: {
      default: null
    },
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
    class: {
      type: [Object, String, Array],
      default: ''
    }
  },
  created(){
    if(!this.modelValue) this.$emit("update:modelValue", {});
  }
};
</script>
